import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
// import PageDescription from '../../PageDescription';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import FiltroTAC from '../../Filtros/FiltroTAC';

class ExtratoTac extends Component {
	render() {
		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"extrato-tac"} image={"extrato-tac"} items={null}/></ErrorBoundary>
				{/* Content page */}
				<ErrorBoundary><FiltroTAC /></ErrorBoundary>
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};
export default ExtratoTac;